import { PageHeader } from '@components/common/PageHeader';
import { SectionCard } from '@components/common/SectionCard';
import { PromotionCatalogPanel } from '@components/accounts/PromotionCatalogPanel';

export function PromotionsPage() {
  return (
    <div className="space-y-8">
      <PageHeader
        title="Promotions"
        subtitle="Manage coupon codes, percentage discounts, fixed-amount discounts, and trial extensions."
      />

      <SectionCard
        title="Promotion Catalog"
        subtitle="Create and retire provisioning codes for CRM promotion and public signup flows."
      >
        <PromotionCatalogPanel />
      </SectionCard>
    </div>
  );
}
